import styled from 'styled-components';

import { StyledTextField } from 'components/Input/styles';

export const EmptyContainer = styled.p`
  display: flex;
  padding: 6px;
  align-items: center;
  margin: 0px;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 12px;
  svg {
    margin-right: 8px;
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;

export const LayoutColumns = styled.div`
  display: flex;
  gap: 16px;
`;

export const FieldsSearchField = styled(StyledTextField)`
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  & .MuiInputBase-root {
    height: 28px;
    padding: 0 6px;
  }
`;

export const FieldsScrollArea = styled.div<{ $distance: number }>`
  overflow-y: auto;
  max-height: calc(100vh - ${({ $distance }) => $distance}px);
`;

export const LayoutScrollArea = styled.div<{ $distance: number }>`
  flex: 1;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  max-height: calc(100vh - ${({ $distance }) => $distance}px);
`;
